import { render } from "./BonusCommissionDetail.vue?vue&type=template&id=3feaf654&scoped=true"
import script from "./BonusCommissionDetail.vue?vue&type=script&lang=js"
export * from "./BonusCommissionDetail.vue?vue&type=script&lang=js"

import "./BonusCommissionDetail.vue?vue&type=style&index=0&id=3feaf654&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feaf654"]])

export default __exports__